import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import moment from "moment";

import Switch from "react-switch";

import CanvasActions from "../../actions/CanvasActions.js";

import "./style.css";

class ThemeOptions extends Component {
  render() {
    return (
      <div className="theme-options">
        {/* <div className="option">
          <Switch
            checkedIcon={false}
            uncheckedIcon={false}
            onChange={() => {
              this.props.setCanvas({
                ...this.props.canvas,
                onWhite: !this.props.canvas.onWhite
              });
            }}
            checked={this.props.canvas.onWhite}
            id="normal-switch"
          />
          <span>On White</span>
        </div> */}
        <div className="option">
          <Switch
            checkedIcon={false}
            uncheckedIcon={false}
            onChange={() => {
              this.props.setCanvas({
                ...this.props.canvas,
                showConstellations: !this.props.canvas.showConstellations
              });
            }}
            checked={this.props.canvas.showConstellations}
            id="normal-switch"
          />
          <span>Constellations</span>
        </div>
        <div className="option">
          <Switch
            checkedIcon={false}
            uncheckedIcon={false}
            onChange={() => {
              this.props.setCanvas({
                ...this.props.canvas,
                showGrid: !this.props.canvas.showGrid
              });
            }}
            checked={this.props.canvas.showGrid}
            id="normal-switch"
          />
          <span>Grid</span>
        </div>
        <div className="option">
          <Switch
            checkedIcon={false}
            uncheckedIcon={false}
            onChange={() => {
              this.props.setCanvas({
                ...this.props.canvas,
                showTime: !this.props.canvas.showTime
              });
            }}
            checked={this.props.canvas.showTime}
            id="normal-switch"
          />
          <span>Show Time with Date</span>
        </div>

        {this.props.canvas.showTime && (
          <div className="text-row">
            <span>Event Time</span>
            <div className="time">
              <input
                type="text"
                value={this.props.canvas.timeDate.getHours()}
                onChange={e => {
                  let newDate = new Date(this.props.canvas.timeDate);
                  newDate.setHours(e.target.value);
                  this.props.setCanvas({
                    ...this.props.canvas,
                    timeDate: newDate
                  });
                }}
              />
              <span>:</span>
              <input
                type="text"
                value={this.props.canvas.timeDate.getMinutes()}
                onChange={e => {
                  let newDate = new Date(this.props.canvas.timeDate);
                  newDate.setMinutes(e.target.value);
                  this.props.setCanvas({
                    ...this.props.canvas,
                    timeDate: newDate
                  });
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    canvas: state.canvas
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCanvas: canvas => {
      dispatch(CanvasActions.setCanvas(canvas));
    }
  };
};

const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(ThemeOptions);

export default App;



// WEBPACK FOOTER //
// ./src/components/ThemeOptions/index.js